
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_ygvxw_94",
  "variant-secondary": "awsui_variant-secondary_4c84z_ygvxw_139",
  "variant-primary": "awsui_variant-primary_4c84z_ygvxw_174",
  "variant-info": "awsui_variant-info_4c84z_ygvxw_209",
  "variant-value-large": "awsui_variant-value-large_4c84z_ygvxw_246",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_ygvxw_280",
  "variant-recovery": "awsui_variant-recovery_4c84z_ygvxw_315",
  "button": "awsui_button_4c84z_ygvxw_350",
  "color-inverted": "awsui_color-inverted_4c84z_ygvxw_387",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_ygvxw_406",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_ygvxw_411",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_ygvxw_415",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_ygvxw_419",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_ygvxw_424",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_ygvxw_429",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_ygvxw_434",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_ygvxw_439",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_ygvxw_444",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_ygvxw_450",
  "icon": "awsui_icon_4c84z_ygvxw_450"
};
  